import { PROXY_PORT } from "@aiux/proxy/index";

export function getTodayDate() {
  const today = new Date();
  const date = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  return `${date}-${month}-${year}`;
}
/**
 * @todo make this dynamic according to the environment later
 */
export const PROXY_URL = `http://localhost:${PROXY_PORT}`;
